import withAPIAction from 'utils/withAPIAction'
import { verifyReq } from 'utils/verify'
import {
  GetCheckingZoneAction,
  AcceptTaskAction,
  RejectTaskAction,
} from './actions'

import {
  GetCheckingZoneReq,
  AcceptCheckingTaskReq,
  RejectCheckingTaskReq,
} from './types'

export const GetCheckingZoneByQC = (
  token: string,
  data: GetCheckingZoneReq
) => {
  const isValid = verifyReq(data, token)
  if (isValid !== undefined) return isValid

  return withAPIAction<GetCheckingZoneReq>({
    method: 'POST',
    path: 'GetCheckingZoneByQC',
    data,
    token: `Bearer ${token}`,
  })(GetCheckingZoneAction)
}

export const AcceptCheckingZoneByQC = (
  token: string,
  data: AcceptCheckingTaskReq
) => {
  const isValid = verifyReq(data, token)
  if (isValid !== undefined) return isValid

  return withAPIAction<AcceptCheckingTaskReq>({
    method: 'POST',
    path: 'AcceptCheckingZoneByQC',
    data,
    token: `Bearer ${token}`,
  })(AcceptTaskAction)
}

export const RejectCheckingZoneByQC = (
  token: string,
  data: RejectCheckingTaskReq
) => {
  const isValid = verifyReq(data, token)
  if (isValid !== undefined) return isValid

  return withAPIAction<RejectCheckingTaskReq>({
    method: 'POST',
    path: 'RejectCheckingZoneByQC',
    data,
    token: `Bearer ${token}`,
  })(RejectTaskAction)
}
